import(/* webpackMode: "eager" */ "/vercel/path1/app/profile/page.tsx");
